if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 1;
        this.totalImages = 0;
        this.images = [];
        this.touchStartX = 0;
        this.touchEndX = 0;
        
        // Set up our own modal event handlers
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
        document.body.appendChild(this);
      }

      hide() {
        // Ensure body is unlocked
        document.body.classList.remove('overflow-hidden');
        super.hide();
      }

      resolveSlideByMediaId(mediaId) {
        if (!mediaId || !this.images?.length) return null;
        const target = String(mediaId);
        const targetOnly = target.split('-').pop();
        return (
          this.images.find((slide) => {
            const slideId = slide.getAttribute('data-media-id') || '';
            const slideOnly = slideId.split('-').pop();
            return (
              slideId === target ||
              slideOnly === target ||
              slideOnly === targetOnly ||
              slideId.endsWith(`-${targetOnly}`)
            );
          }) || null
        );
      }

      show(opener) {
        super.show(opener);
        document.body.classList.add('overflow-hidden');
        const sectionId = this.id.replace('ProductModal-', '');
        this.syncModalSlidesFromGallery(sectionId);
        setTimeout(() => {
          this.initializeModal();
          this.setupNavigation();
          this.showActiveMedia();
        }, 100);
      }

      syncModalSlidesFromGallery(sectionId) {
        if (window.ciwVariantMediaHandler) {
          const variantId = document.querySelector('input[name="id"]')?.value;
          if (variantId) {
            window.ciwVariantMediaHandler.updateAdditionalMediaFromCurrentPage(variantId, sectionId);
            return;
          }
        }

        const viewer = document.getElementById(`GalleryViewer-${sectionId}`);
        const modalContainer = this.querySelector('.ci-modal-container > div');
        if (!viewer || !modalContainer) return;

        const visibleSlides = Array.from(viewer.querySelectorAll('.ci-gallery-slide')).filter(
          (slide) => !slide.hasAttribute('hidden') && slide.style.display !== 'none'
        );

        this.querySelectorAll('.ci-modal-slide').forEach((slide) => {
          slide.style.setProperty('display', 'none', 'important');
        });

        visibleSlides.forEach((gallerySlide) => {
          const mediaId = gallerySlide.getAttribute('data-media-id') || '';
          const mediaIdOnly = mediaId.split('-').pop();
          let modalSlide =
            this.querySelector(`.ci-modal-slide[data-media-id="${mediaId}"]`) ||
            this.querySelector(`.ci-modal-slide[data-media-id="${mediaIdOnly}"]`) ||
            this.querySelector(`.ci-modal-slide[data-media-id$="-${mediaIdOnly}"]`);

          if (!modalSlide) {
            const img = gallerySlide.querySelector('img');
            if (!img) return;

            modalSlide = document.createElement('div');
            modalSlide.className = 'ci-modal-slide';
            modalSlide.setAttribute('data-media-id', mediaIdOnly || mediaId);
            const slideVariantId = gallerySlide.getAttribute('data-variant-id');
            if (slideVariantId) {
              modalSlide.setAttribute('data-variant-id', slideVariantId);
            }

            const modalImg = document.createElement('img');
            modalImg.src = img.currentSrc || img.src;
            modalImg.alt = img.alt || 'Product image';
            modalImg.className = 'global-media-settings global-media-settings--no-shadow ciw-pdp-modal__img';
            modalSlide.appendChild(modalImg);
            modalContainer.appendChild(modalSlide);
          }

          modalSlide.style.removeProperty('display');
        });
      }

      initializeModal() {
        const allSlides = Array.from(this.querySelectorAll('.ci-modal-slide'));

        this.images = allSlides.filter((slide) => window.getComputedStyle(slide).display !== 'none');
        this.totalImages = this.images.length;

        this.images.forEach((slide, index) => {
          slide.setAttribute('data-index', index + 1);
        });

        let selectedIndex = 0;
        const targetMediaId =
          window.mediaModalId || this.openedBy?.getAttribute('data-media-id');
        if (targetMediaId) {
          const targetSlide = this.resolveSlideByMediaId(targetMediaId);
          if (targetSlide) {
            const indexed = parseInt(targetSlide.getAttribute('data-index'), 10);
            selectedIndex = indexed > 0 ? indexed - 1 : this.images.indexOf(targetSlide);
          }
        }

        const totalCounter = this.querySelector(`[id^="total-images"]`);
        if (totalCounter) {
          totalCounter.textContent = this.totalImages;
        }

        if (this.currentIndex > this.totalImages) {
          this.currentIndex = 1;
        }

        this.showImageAtIndex(selectedIndex + 1);
      }

      // Method to reinitialize modal when slides change dynamically
      reinitialize() {
        this.initializeModal();
        this.setupNavigation();
      }

      setupNavigation() {
        console.log(`[Modal Nav] Setting up navigation for ${this.totalImages} images`);
        
        const prevBtn = this.querySelector(`[id^="PrevImage"]`);
        const nextBtn = this.querySelector(`[id^="NextImage"]`);
        const counter = this.querySelector(`[id^="current-image"]`).parentElement;
        
        // Remove existing event listeners by cloning elements (this removes all listeners)
        if (this.navigationSetup) {
          console.log(`[Modal Nav] Removing existing navigation listeners`);
          if (prevBtn && this.prevClickHandler) {
            prevBtn.removeEventListener('click', this.prevClickHandler);
            prevBtn.removeEventListener('touchend', this.prevClickHandler);
          }
          if (nextBtn && this.nextClickHandler) {
            nextBtn.removeEventListener('click', this.nextClickHandler);
            nextBtn.removeEventListener('touchend', this.nextClickHandler);
          }
        }
        
        // Create bound handlers to store for removal later
        this.prevClickHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log(`[Modal Nav] Previous button clicked`);
          this.previousImage();
        };
        
        this.nextClickHandler = (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log(`[Modal Nav] Next button clicked`);
          this.nextImage();
        };
        
        // Add event listeners to prevent modal closing on navigation clicks
        [prevBtn, nextBtn, counter].forEach(element => {
          if (element) {
            element.addEventListener('pointerup', (e) => {
              e.stopPropagation();
            });
            element.addEventListener('click', (e) => {
              e.stopPropagation();
            });
            element.addEventListener('touchend', (e) => {
              e.stopPropagation();
            });
          }
        });
        
        if (prevBtn) {
          prevBtn.addEventListener('click', this.prevClickHandler);
          prevBtn.addEventListener('touchend', this.prevClickHandler);
        }
        
        if (nextBtn) {
          nextBtn.addEventListener('click', this.nextClickHandler);
          nextBtn.addEventListener('touchend', this.nextClickHandler);
        }

        // Keyboard navigation - only add once
        if (!this.navigationSetup) {
          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
              e.preventDefault();
              this.previousImage();
            } else if (e.key === 'ArrowRight') {
              e.preventDefault();
              this.nextImage();
            }
          });

          // Touch/Swipe navigation
          this.setupSwipeNavigation();
        }

        // Hide navigation arrows if only one image
        if (this.totalImages <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
          console.log(`[Modal Nav] Hiding navigation arrows (only ${this.totalImages} image)`);
        } else {
          if (prevBtn) prevBtn.style.display = '';
          if (nextBtn) nextBtn.style.display = '';
          console.log(`[Modal Nav] Showing navigation arrows (${this.totalImages} images)`);
        }
        
        this.navigationSetup = true;
      }

      setupSwipeNavigation() {
        const imageContainer = this.querySelector('.ci-modal-container');
        
        if (imageContainer) {
          imageContainer.addEventListener('touchstart', (e) => {
            this.touchStartX = e.changedTouches[0].screenX;
          }, { passive: true });

          imageContainer.addEventListener('touchend', (e) => {
            this.touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
          }, { passive: true });
        }
      }

      handleSwipe() {
        const swipeThreshold = 50; // Minimum distance for a swipe
        const swipeDistance = this.touchEndX - this.touchStartX;

        if (Math.abs(swipeDistance) > swipeThreshold) {
          if (swipeDistance > 0) {
            // Swipe right - go to previous image
            this.previousImage();
          } else {
            // Swipe left - go to next image
            this.nextImage();
          }
        }
      }

      showActiveMedia() {
        // Add a small delay to ensure any reinitialize calls from variant handlers have completed
        setTimeout(() => {
          const targetMediaId =
            this.openedBy?.getAttribute('data-media-id') || window.mediaModalId;
          console.log(`[Modal Active] Looking for slide with media-id: ${targetMediaId}`);

          const targetImage = this.resolveSlideByMediaId(targetMediaId);

          if (targetImage) {
            const targetIndex = parseInt(targetImage.getAttribute('data-index'), 10);
            console.log(`[Modal Active] Found target slide with index: ${targetIndex}, showing it`);
            this.showImageAtIndex(targetIndex > 0 ? targetIndex : this.images.indexOf(targetImage) + 1);
          } else {
            console.log(`[Modal Active] Target slide not found, falling back to index 1`);
            this.showImageAtIndex(1);
          }
        }, 50);
      }

      showImageAtIndex(index) {
        // Hide all images
        this.images.forEach(img => {
          img.style.visibility = 'hidden';
          img.style.opacity = '0';
        });

        // Show target image
        const targetImage = this.images.find(img => 
          parseInt(img.getAttribute('data-index')) === index
        );

        if (targetImage) {
          targetImage.style.visibility = 'visible';
          targetImage.style.opacity = '1';
          this.currentIndex = index;
          
          // Update counter
          const currentCounter = this.querySelector(`[id^="current-image"]`);
          if (currentCounter) {
            currentCounter.textContent = this.currentIndex;
          }

          // Load deferred media if needed
          const deferredMedia = targetImage.querySelector('.deferred-media');
          if (deferredMedia) {
            deferredMedia.loadContent(false);
          }
        }
      }

      previousImage() {
        const newIndex = this.currentIndex > 1 ? this.currentIndex - 1 : this.totalImages;
        this.showImageAtIndex(newIndex);
      }

      nextImage() {
        const newIndex = this.currentIndex < this.totalImages ? this.currentIndex + 1 : 1;
        this.showImageAtIndex(newIndex);
      }
    }
  );
}
